import { Injectable, inject } from '@angular/core';
import { Store, select } from '@ngrx/store';

import * as WagerActions from './wager.actions';
import * as WagerSelectors from './wager.selectors';
// import { Observable, take } from 'rxjs';
import {
  IEventDetail,
  IGetEventsDetailsResponse,
  IGetResultRequest,
  IPusherDataURC,
  IRace,
  TError,
  IToteWageringGetCountersResponse,
  IGeoLocationModel,
  IGetPoolMatrixRequest,
  IGetPoolsTotalsRequest,
  IGetRaceAllOddsMatrixesRequest,
  IPusher,
  IGetRCNReplayVideosByFiltersRequest,
  IGetRaceVideoRequest,
  IGetRCNReplayVideoLinkRequest,
  IGetEloRatingsRequest
} from '@amwager/util-ts';
import { Observable } from 'rxjs';
import { IBet, IBetStackTicket, IBetTicket, IGetBets, ITicketSlim } from './wager.models';



@Injectable()
export class WagerFacade {
  private readonly store = inject(Store);

  // Selectors — expose store state as observables

  isEventTrackRaceRequestingAPI$(): Observable<TError> {
    return this.store.pipe(select(WagerSelectors.isEventTrackRaceRequestingAPI));
  }

  isLoaded$(): Observable<TError> {
    return this.store.pipe(select(WagerSelectors.getEventTrackRaceLoaded));
  }

  isError$(): Observable<TError> {
    return this.store.pipe(select(WagerSelectors.getEventTrackRaceError));
  }

  selectedId$(): Observable<TError> {
    return this.store.pipe(select(WagerSelectors.getSelectedEventTrackRaceId));
  }


  getSelectEventTrackRaceState$() {
    return this.store.pipe(select(WagerSelectors.getSelectEventTrackRaceState));
  }

  getSelectEventTrackRaceIds$() {
    return this.store.pipe(select(WagerSelectors.getSelectEventTrackRaceIds));
  }

  getSelectEventTrackRaceEntities$() {
    return this.store.pipe(select(WagerSelectors.getSelectEventTrackRaceEntities));
  }

  getSelectAllEventTrackRace$() {
    return this.store.pipe(select(WagerSelectors.getSelectAllEventTrackRace));
  }

  getSelectEventTrackRaceTotal$() {
    return this.store.pipe(select(WagerSelectors.getSelectEventTrackRaceTotal));
  }

  getSelectedEventTrack$() {
    return this.store.pipe(select(WagerSelectors.getSelectedEventTrack));
  }

  getRaceResult$() {
    return this.store.pipe(select(WagerSelectors.getRaceResult));
  }

  getRaceMatrix$() {
    return this.store.pipe(select(WagerSelectors.getRaceMatrix));
  }

  getRaceMatrixReplay$() {
    return this.store.pipe(select(WagerSelectors.getRaceMatrixReplay));
  }

  getRacePoolsTotals$() {
    return this.store.pipe(select(WagerSelectors.getRacePoolsTotals));
  }

  getReplayRaceMatrix$() {
    return this.store.pipe(select(WagerSelectors.getReplayRaceMatrix));
  }

  getReplayRacePoolsTotals$() {
    return this.store.pipe(select(WagerSelectors.getReplayRacePoolsTotals));
  }

  getReplayRaceWillPays$() {
    return this.store.pipe(select(WagerSelectors.getReplayRaceWillPays));
  }

  getReplayRaceAllOddsMatrixes$() {
    return this.store.pipe(select(WagerSelectors.getReplayRaceAllOddsMatrixes));
  }

  getRaceWillPays$() {
    return this.store.pipe(select(WagerSelectors.getRaceWillPays));
  }

  getSelectedRace$() {
    return this.store.pipe(select(WagerSelectors.getSelectedRace));
  }

  getRaceAllOddsMatrixes$() {
    return this.store.pipe(select(WagerSelectors.getRaceAllOddsMatrixes));
  }

  getEloRatings$() {
    return this.store.pipe(select(WagerSelectors.getEloRatings));
  }

  getDataPrograms$() {
    return this.store.pipe(select(WagerSelectors.getDataPrograms));
  }

  getDataProgramDownload$() {
    return this.store.pipe(select(WagerSelectors.getDataProgramDownload));
  }



  // get bet section
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getCounters$(): Observable<any> {
    return this.store.pipe(select(WagerSelectors.getCounters));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getBets$(): Observable<any> {
    return this.store.pipe(select(WagerSelectors.getBets));
  }

  isSubmitSavedBetSuccess$(): Observable<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response: any,
    isSuccess: boolean | undefined
  }> {
    return this.store.pipe(select(WagerSelectors.submitSavedBetSuccess));
  }

  isRemoveSavedBetSuccess$(): Observable<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response: any,
    isSuccess: boolean | undefined
  }> {
    return this.store.pipe(select(WagerSelectors.removeSavedBetSuccess));
  }

  isCancelBetSuccess$(): Observable<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response: any,
    isSuccess: boolean | undefined
  }> {
    return this.store.pipe(select(WagerSelectors.cancelBetSuccess));
  }

  isSaveBetSuccess$(): Observable<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response: any,
    isSuccess: boolean | undefined,
    isProcessing: boolean | undefined
  }> {
    return this.store.pipe(select(WagerSelectors.saveBetSuccess));
  }

  isBetNowSuccess$(): Observable<{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response: any,
    isSuccess: boolean | undefined,
    isProcessing: boolean | undefined
  }> {
    return this.store.pipe(select(WagerSelectors.betAmountSuccess));
  }

  isShowBetPreview$(): Observable<boolean> {
    return this.store.select(WagerSelectors.getIsShowBetPreview);
  }

  // isBetAmountSuccess$(): Observable<{
  //   // eslint-disable-next-line @typescript-eslint/no-explicit-any
  //   response: any,
  //   isProcessing: boolean | undefined
  // }> {
  //   return this.store.pipe(select(WagerSelectors.betAmountSuccess));
  // }

 /**
   * Get ticket
   *
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getTicket$(): Observable<any> {
    return this.store.pipe(select(WagerSelectors.getTicket));
  }

  getTicketGeoLocation$(): Observable<any> {
    return this.store.pipe(select(WagerSelectors.getGeoLocation));
  }

  triggerMatrixModal$():  Observable<any> {
    return this.store.pipe(select(WagerSelectors.getTriggerMatrixModal));
  }

  toUpdateGeneralEvents$():  Observable<any> {
    return this.store.pipe(select(WagerSelectors.getToUpdateGeneralEvents));
  }

  getAllEventsNameAndId$():  Observable<any> {
    return this.store.pipe(select(WagerSelectors.getAllEventsNameAndId));
  }

  getReplays$() {
    return this.store.pipe(select(WagerSelectors.getReplays));
  }

  getRunners$() {
    return this.store.pipe(select(WagerSelectors.getRunners));
  }



  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   *
   * Dispatches: Requests only, from WagerActionss
   */


  /**
   * Initialize the wager state (idempotent — do not call multiple times)
   * @param {string} sourceInitiator Component that triggered init
   * @returns {void}
   */
  initState(sourceInitiator: string): void {
    return;
    // this.store.select(WagerSelectors.getWagerLoaded)
    //   .pipe(take(1))
    //   .subscribe(isLoaded => {
    //     isLoaded
    //       ? null
    //       : this.store.dispatch(WagerActions.initWagerState({ sourceInitiator }))
    //   });

    /**
     * EventTrack
     */
    // this.store.select(WagerSelectors.getEventTrackLoaded)
    //   .pipe(take(1))
    //   .subscribe(isLoaded => {
    //     isLoaded
    //       ? null
    //       : this.store.dispatch(WagerActions.initWagerState({ sourceInitiator }))
    //   });
  }
  clearState(sourceInitiator: string): void {
    this.store.dispatch(WagerActions.clearWagerState({ sourceInitiator }));
  }

  setError(error: TError): void {
    this.store.dispatch(WagerActions.setError({ error }));
  }

  // setCurrentRace(sourceInitiator: string, currentRace: IRace, id: string): void {
  //   this.store.dispatch(WagerActions.setCurrentRace({
  //     sourceInitiator,
  //     currentRace,
  //     id
  //   }));
  // }

  selectedEventTrack(sourceInitiator: string, selectedEventTrack: IGetEventsDetailsResponse): void {
    this.store.dispatch(WagerActions.selectedEventTrack({
      sourceInitiator,
      selectedEventTrack
    }));
  }

  selectedRace(sourceInitiator: string, selectedRace: IRace & {runId:string, eventId:string}): void {
    this.store.dispatch(WagerActions.selectedRace({
      sourceInitiator,
      selectedRace,
      eventId: selectedRace?.eventId,
      runId: selectedRace?.runId
    }));
  }

  updateRace(sourceInitiator: string, data: IPusherDataURC): void {
    this.store.dispatch(WagerActions.updateRace({
      sourceInitiator,
      data
    }));
  }

  updateRaceFinal(sourceInitiator: string, data: IPusher): void {
    this.store.dispatch(WagerActions.updateRaceFinal({
      sourceInitiator,
      data
    }));
  }

  updateRaceCancelled(sourceInitiator: string, data: IPusher): void {
    this.store.dispatch(WagerActions.updateRaceCancelled({
      sourceInitiator,
      data
    }));
  }

  updateRaceClosed(sourceInitiator: string, data: IPusher): void {
    this.store.dispatch(WagerActions.updateRaceClosed({
      sourceInitiator,
      data
    }));
  }

  updateRaceOpen(sourceInitiator: string, data: IPusher): void {
    this.store.dispatch(WagerActions.updateRaceOpen({
      sourceInitiator,
      data
    }));
  }

  updateRacePost(sourceInitiator: string, data: IPusher): void {
    this.store.dispatch(WagerActions.updateRacePost({
      sourceInitiator,
      data
    }));
  }

  getAllEvents(): void {
    this.store.dispatch(WagerActions.getAllEventsAPI());
  }

  getEventsDetails(
    sourceInitiator: string,
    isAutoUpdate?: boolean,
    runId?: string,
    isReplay?: boolean
  ): void {
    this.store.dispatch(WagerActions.getEventsDetailsAPI({
      sourceInitiator,
      runId: runId || '',
      isAutoUpdate,
      replay: isReplay
    }));
  }

  getEventDetail(sourceInitiator: string, eventId: string, runId: string, replay?: boolean): void {
    this.store.dispatch(WagerActions.getEventDetailAPI({
      sourceInitiator,
      eventId,
      runId,
      callOrigin: 0,
      replay
    }));
  }

  updateEventsDetails(data: IGetEventsDetailsResponse[]): void {
    this.store.dispatch(WagerActions.getEventsDetailsAPISuccess({
      successResponse: data
    }));
  }

  getRaceResultAPI(requests: IGetResultRequest & { runId: number }, sourceInitiator: string, replay?: boolean): void {
    this.store.dispatch(WagerActions.getRaceResultAPI({
      ...requests,
      runId: String(requests.runId),
      sourceInitiator,
      replay
    }));
  }

  updateResultsPersonalStatistics(sourceInitiator: string, countersAPISuccessData: IToteWageringGetCountersResponse) : void {
    this.store.dispatch(WagerActions.updateResultsPersonalStatistics({
      sourceInitiator,
      countersAPISuccessData
    }));
  }

  // bet section
  getCountersAPI(runId: string, sourceInitiator: string): void {
    this.store.dispatch(WagerActions.getCountersAPI({
      runId,
      sourceInitiator
    }));
  }

  getBetsAPI(
    bet: IBet, status: 'close' | 'saved' | 'active', sourceInitiator: string, replay?: boolean
  ): void {
    this.store.dispatch(WagerActions.getBetsAPI({
      bet,
      sourceInitiator,
      status,
      replay
    }));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  submitSavedBetAPI(ticket: ITicketSlim): void {
    this.store.dispatch(WagerActions.submitSavedBetAPI({
      ticket
    }));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeSavedBetAPI(ticket: ITicketSlim): void {
    this.store.dispatch(WagerActions.removeSavedBetAPI({
      ticket
    }));
  }

  cancelBetAPI(ticket: ITicketSlim): void {
    this.store.dispatch(WagerActions.cancelBetAPI({
      ticket
    }));
  }

  saveBetAPI(
    betTicket: IBetTicket
    // betStackTicket: IBetStackTicket
  ): void {
    this.store.dispatch(WagerActions.saveBetAPI({
      betTicket
    }));
  }

  betNowAPI(
    betTicket: IBetTicket
  ): void {
    this.store.dispatch(WagerActions.betNowAPI({
      betTicket
    }));
  }

  setIsShowBetPreview(isShowBetPreview: boolean): void {
    this.store.dispatch(WagerActions.setIsShowBetPreview({ isShowBetPreview }));
  }

  setTicket(
    bet: IBetTicket
  ): void {
    this.store.dispatch(WagerActions.setTicket({
      bet
    }));
  }

  setGeoLocation(
    location: IGeoLocationModel,
    sourceInitiator: string,
  ): void {
    this.store.dispatch(WagerActions.setGeoLocation({
      sourceInitiator,
      location
    }));
  }

  getPoolMatrix(sourceInitiator: string, requests: IGetPoolMatrixRequest, fromPusher: boolean = false): void {
    this.store.dispatch(WagerActions.getPoolMatrixAPI({
      sourceInitiator,
      requests,
      fromPusher
    }));
  }

  getPoolsTotals(sourceInitiator: string, requests: IGetPoolsTotalsRequest, fromPusher: boolean = false): void {
    this.store.dispatch(WagerActions.getPoolsTotalsAPI({
      sourceInitiator,
      requests,
      fromPusher
    }));
  }

  getWillPays(sourceInitiator: string, requests: {
    raceId: number;
    eventId: string;
    runId: string;
    replay?: boolean
  }): void {
    this.store.dispatch(WagerActions.getWillPaysAPI({
      sourceInitiator,
      requests
    }));
  }

  getRaceAllOddsMatrixes(sourceInitiator: string, pool: 'WIN' | 'TRU', requests: IGetRaceAllOddsMatrixesRequest, fromPusher: boolean = false): void {
    this.store.dispatch(WagerActions.getRaceAllOddsMatrixesAPI({
      sourceInitiator,
      requests,
      pool,
      fromPusher
    }));
  }

  // Fetch per-runner Elo ratings for a race (no pusher; driven by race selection)
  getEloRatings(sourceInitiator: string, requests: IGetEloRatingsRequest): void {
    this.store.dispatch(WagerActions.getEloRatingsAPI({
      sourceInitiator,
      requests
    }));
  }

  clearEloRatings(sourceInitiator: string): void {
    return this.store.dispatch(WagerActions.clearEloRatings({ sourceInitiator }));
  }

  // Fetch the programs on sale for a race date
  getDataPrograms(sourceInitiator: string, date: string): void {
    this.store.dispatch(WagerActions.getDataProgramsAPI({
      sourceInitiator,
      date
    }));
  }

  // Download a program, buying it when the account does not own it yet
  downloadDataProgram(sourceInitiator: string, raceDate: string, productId: string): void {
    this.store.dispatch(WagerActions.downloadDataProgramAPI({
      sourceInitiator,
      raceDate,
      productId
    }));
  }

  clearDataProgramDownload(sourceInitiator: string): void {
    return this.store.dispatch(WagerActions.clearDataProgramDownload({ sourceInitiator }));
  }

  updateRaceMatrix(sourceInitiator: string, matrix: any): void {
    this.store.dispatch(WagerActions.updateRaceMatrix({
      sourceInitiator,
      matrix
    }));
  }

  updateRacePoolsTotals(sourceInitiator: string, poolsTotals: any): void {
    this.store.dispatch(WagerActions.updateRacePoolsTotals({
      sourceInitiator,
      poolsTotals
    }));
  }

  updateTriggerMatrixModal(sourceInitiator: string): void {
    this.store.dispatch(WagerActions.triggerMatrixModal({
      sourceInitiator
    }));
  }

  toUpdateGeneralEvents(sourceInitiator: string): void {
    this.store.dispatch(WagerActions.toUpdateGeneralEvents({
      sourceInitiator
    }));
  }

  getEventRaceVideoLive(sourceInitiator: string, request: IGetRaceVideoRequest, typeVideo: 'default' | 'IGB'): void {
    this.store.dispatch(WagerActions.getEventRaceVideoLiveAPI({
      sourceInitiator,
      request,
      typeVideo
    }));
  }

  getEventRaceVideoReplay(sourceInitiator: string, request: IGetRCNReplayVideoLinkRequest): void {
    this.store.dispatch(WagerActions.getEventRaceVideoReplayAPI({
      sourceInitiator,
      request
    }));
  }

  getAllEventsNameAndId(sourceInitiator: string): void {
    this.store.dispatch(WagerActions.getAllEventsNameAndIdAPI({
      sourceInitiator
    }));
  }

  getReplays(sourceInitiator: string, requests: IGetRCNReplayVideosByFiltersRequest): void {
    this.store.dispatch(WagerActions.getReplaysAPI({
      sourceInitiator,
      requests
    }));
  }

  getRunners(runnerPrefix: string): void {
    if (!runnerPrefix) return;
    this.store.dispatch(WagerActions.getRunnersAPI({
      runnerPrefix
    }));
  }

  getRace(sourceInitiator: string, raceId: number, runId: string, eventId: string): void {
    this.store.dispatch(WagerActions.getRaceAPI({
      sourceInitiator,
      raceId,
      runId,
      eventId
    }));
  }

  // live video
  // setCountryStates(subdivisions: any): void {
  //   return this.store.dispatch(AuthActions.setCountryStates({ subdivisions }));
  // }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setEventLiveVideo(liveEventVideo: any): void {
    return this.store.dispatch(WagerActions.setEventLiveVideo({ liveEventVideo }));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getEventLiveVideo$(): Observable<any> {
    return this.store.pipe(select(WagerSelectors.getEventLiveVideo));
  }

  setSelectedReplayInfo(
    track: string,
    date: string,
    breed: string,
    race: string,
    runId?: string | boolean,
    eventId?: string,
    poolId?: string,
    showOdds?: boolean
  ): void {
    return this.store.dispatch(WagerActions.setSelectedReplayInfo({
      track, date, breed, race, runId, eventId, poolId, showOdds
    }));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getSelectedReplayInfo$(): Observable<any> {
    return this.store.pipe(select(WagerSelectors.getSelectedReplayInfo));
  }

  setLatestFinishedEvent(latestEvent: IGetEventsDetailsResponse, raceId?: number): void {
    return this.store.dispatch(WagerActions.setLatestFinishedEvent({ latestEvent, raceId }));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getLatestFinishedEvent$(): Observable<any> {
    return this.store.pipe(select(WagerSelectors.getLatestFinishedEvent));
  }

  clearRaceAllOddsMatrixes(sourceInitiator: string): void {
    return this.store.dispatch(WagerActions.clearRaceAllOddsMatrixes({ sourceInitiator }));
  }

  clearSelectedRaceMatrix(sourceInitiator: string): void {
    return this.store.dispatch(WagerActions.clearSelectedRaceMatrix({ sourceInitiator }));
  }

  clearSelectedRacePoolsTotals(sourceInitiator: string): void {
    return this.store.dispatch(WagerActions.clearSelectedRacePoolsTotals({ sourceInitiator }));
  }

  clearSelectedRaceWillPays(sourceInitiator: string): void {
    return this.store.dispatch(WagerActions.clearSelectedRaceWillPays({ sourceInitiator }));
  }

  clearReplayMatrix(sourceInitiator: string): void {
    return this.store.dispatch(WagerActions.clearReplayMatrix({ sourceInitiator }));
  }

  setDefaultEvent(isSetDefaultEvent: boolean): void {
    this.store.dispatch(WagerActions.setDefaultEvent({ isSetDefaultEvent }));
  }

  getDefaultEvent$(): Observable<any> {
    return this.store.pipe(select(WagerSelectors.getDefaultEvent));
  }

  setEventResultToShow(
    eventId: string, race: string, runId: string, eventDate: string, runners: any
  ): void {
    this.store.dispatch(WagerActions.setEventResultToShow({
      eventId, race, runId, eventDate, runners
    }));
  }

  getEventResultToShow$(): Observable<any> {
    return this.store.pipe(select(WagerSelectors.getEventResultToShow));
  }

  setEventReplayVideo(video: string): void {
    return this.store.dispatch(WagerActions.setEventReplayVideo({ video }));
  }

  getPreviousEventResult$(): Observable<any> {
    return this.store.pipe(select(WagerSelectors.getPreviousEventResult));
  }

  getReplayEventResult$(): Observable<any> {
    return this.store.pipe(select(WagerSelectors.getReplayEventResult));
  }

  setReplayEventResult(successResponse: any, previousEventsResult?: any): void {
    this.store.dispatch(WagerActions.setReplayEventResult({
      successResponse,
      previousEventsResult
    }));
    // return this.store.pipe(select(WagerActions.setReplayEventResult));
  }

  getReplayEventDetail$(): Observable<any> {
    return this.store.pipe(select(WagerSelectors.getReplayEventDetail));
  }

  setReplayEventDetail(successResponse: any): void {
    this.store.dispatch(WagerActions.setReplayEventDetail({
      successResponse
    }));
    // return this.store.pipe(select(WagerActions.setReplayEventDetail));
  }

  getReplayBets$(): Observable<any> {
    return this.store.pipe(select(WagerSelectors.getReplayBets));
  }

  setReplayBets(): Observable<any> {
    return this.store.pipe(select(WagerActions.setReplayBets));
  }

  getReplayMatrix$(): Observable<any> {
    return this.store.pipe(select(WagerSelectors.getReplayMatrix));
  }

  setReplayMatrix(event?: any, race?: any, eventId?: string, runId?: string): void {
    return this.store.dispatch((WagerActions.setReplayMatrix({event, race, eventId, runId})));
  }

  isRefreshWager$(): Observable<any> {
    return this.store.pipe(select(WagerSelectors.getRefreshWager));
  }

  setRefreshWager(trigger: boolean): void {
    return this.store.dispatch((WagerActions.setRefreshWager({trigger})));
  }

  getAllEventsByDate(requestedDateStr: string): void {
    this.store.dispatch(WagerActions.getAllEventsByDateAPI({
      requestedDateStr
    }));
  }

  getAllEventsByDate$(): Observable<any> {
    return this.store.pipe(select(WagerSelectors.getAllEventsByDate));
  }

  setAllEventsByDate(successResponse: any): void {
    this.store.dispatch(WagerActions.setAllEventsByDate({
      successResponse
    }));
  }

  setReplayEventsDetails(successResponse: any): void {
    this.store.dispatch(WagerActions.setReplayEventsDetails({
      successResponse
    }));
  }

  getReplayEventsDetails$(): Observable<any> {
    return this.store.pipe(select(WagerSelectors.getReplayEventsDetails));
  }

  setEventRaceVideoReplay(successResponse: any): void {
    this.store.dispatch(WagerActions.setEventRaceVideoReplay({
      successResponse,
      eventId: ''
    }));
  }
}
